module.exports = __webpack_public_path__ + "static/media/one_to_one_icon_blue_bg.aeecedc5.svg";